module.exports = __webpack_public_path__ + "img/man_child_face.2fcabee2.png";